import { Link } from 'react-router-dom';
import { ShoppingBag, SearchCheck, FileClock, Wrench, Tags, PlayCircle, ArrowUpRight } from 'lucide-react';
import { ACCENTS } from '../../lib/academyApi';

const ICONS = { ShoppingBag, SearchCheck, FileClock, Wrench, Tags, PlayCircle };

export const CategoryCard = ({ category }) => {
  const accent = ACCENTS[category.accent] || ACCENTS.orange;
  const Icon = ICONS[category.icon] || ShoppingBag;
  const to = category.slug === 'videos' ? '/academy/videos' : `/academy/category/${category.slug}`;

  return (
    <Link
      to={to}
      className="group relative rounded-2xl overflow-hidden border border-zinc-800/80 bg-[#161618] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-zinc-700"
      data-testid={`category-card-${category.slug}`}
    >
      <div className={`absolute -top-16 -right-16 w-40 h-40 blur-3xl rounded-full ${accent.glow} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
      <div className="relative">
        <div className={`grid place-items-center w-12 h-12 rounded-xl bg-gradient-to-br ${accent.grad} shadow-lg mb-5`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
        <div className="flex items-start justify-between gap-3">
          <h3 className="text-xl font-bold text-white" style={{ fontFamily: 'Space Grotesk' }}>
            {category.name}
          </h3>
          <ArrowUpRight className={`w-5 h-5 shrink-0 ${accent.text} opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all`} />
        </div>
        <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{category.description}</p>
        {typeof category.articleCount === 'number' && (
          <p className="mt-4 text-xs font-medium text-zinc-500 uppercase tracking-wide">
            {category.slug === 'videos'
              ? 'Watch now'
              : `${category.articleCount} ${category.articleCount === 1 ? 'article' : 'articles'}`}
          </p>
        )}
      </div>
    </Link>
  );
};

export default CategoryCard;
